import URI from 'urijs';
import { standardHeaders, contentTypes } from '../constants';

class Http {

    constructor(){
        this.defaultHeaders = {};
        this.encoders = {};
        this.encoders[contentTypes.APPLICATION_JSON] = JSON.stringify;
        this.encoders[contentTypes.FORM_DATA] = Http.urlEncodeParams;
    }

    getEncoder(contentType){
        return this.encoders[contentType];
    }

    static urlEncodeParams(params){
        return Object.keys(params).map(key => {
            let value = encodeURIComponent(params[key]);
            return `${key}=${value}`;
        }).join('&');
    }

    setDefaultHeaders(headers) {
        Object.assign(this.defaultHeaders, headers);
    }

    _parse(req) {
        var result;
        try {
            result = JSON.parse(req.response);
        } catch (e) {
            result = req.response;
        }
        return result;
    }

    _parseParams(params) {
        return '?' + Object.keys(params).map(key => {
            let value = params[key];
            return [key, value].join('=');
        }).join('&');
    }

    _ajx(method, url, data, config) {

        var methods = {
            success: function () {
            },
            error: function () {
            }
        };

        let headers = Object.assign({}, this.defaultHeaders, config.headers);
        headers = typeof headers === 'object' ? headers : {};
        headers[standardHeaders.CONTENT_TYPE] = headers[standardHeaders.CONTENT_TYPE] || contentTypes.APPLICATION_JSON;

        if (method === 'GET') {
            let queryString = (typeof data === 'object' && !Array.isArray(data)) ? this._parseParams(data) : '';
            url = url + queryString;
        }

        // Add Cache Busting - required for IE (yes, we should add it to non GET requests too)
        url = URI(url)
            .addSearch('_', new Date().getTime());

        var XHR = window.XMLHttpRequest;
        var request = new XHR('MSXML2.XMLHTTP.3.0');
        var isAsync = (typeof config.async === 'boolean') ? config.async : true;
        request.open(method, url, isAsync);

        // if (!config.awsupload) {
        //     var auth = localStorage.getItem(TOKEN);
        //     request.setRequestHeader(standardHeaders.AUTHORIZATION, auth || '');
        //     request.setRequestHeader(standardHeaders.CONTENT_TYPE, contentTypes.APPLICATION_JSON);
        // }

        Object.keys(headers).forEach(key => {
            let header = headers[key];
            request.setRequestHeader(key, header);
        });

        if (config.responseType) {
            request.responseType = config.responseType;
        }

        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                if (request.status >= 200 && request.status < 300) {
                    methods.success(this._parse(request), request.status, request);
                } else {
                    methods.error(this._parse(request), request.status, request);
                }
            }
        }
        let encoder = this.getEncoder(headers[standardHeaders.CONTENT_TYPE]);
        data = encoder(data);

        request.send(data)
        var callbacks = {
            success: function (callback) {
                methods.success = callback;
                return callbacks;
            },
            error: function (callback) {
                methods.error = callback;
                return callbacks;
            }
        };

        if (config.async === false) {
            return request;
        } else {
            return callbacks;
        }
    }

    get(url, data, config = {}) {
        return this._ajx('GET', url, data, config);
    }

    post(url, data, config = {}) {
        return this._ajx('POST', url, data, config);
    }

    put(url, data, config = {}) {
        return this._ajx('PUT', url, data, config);
    }

    del(url, data, config = {}) {
        return this._ajx('DELETE', url, data, config);
    }

    // s3upload(formdata) {
    //     let config = {
    //         awsupload: true,
    //         contentType: 'multipart/form-data'
    //     };
    //     return this._ajx('POST', 'https://cql-labs.s3.amazonaws.com', formdata, config);
    // }
}

const http = new Http();

export default http;



// WEBPACK FOOTER //
// ./web-app/utils/http.js